import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IncidentService } from './incident.service';
import { from } from 'rxjs';

@Injectable()
export class AnonymousReportInterceptor implements HttpInterceptor {
  constructor(private incidentService: IncidentService) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return from(this.handle(req, next));
  }

  async handle(req: HttpRequest<any>, next: HttpHandler): Promise<any> {
    //TODO should perhaps just be attached in case we don't have credentials (await this.authService.getAuthToken() === null)
    const tenantId = await this.incidentService.getTenantID();
    if (tenantId) {
      req = req.clone({
        setHeaders: {
          'x-tenant-id': tenantId,
        },
      });
    }

    return next.handle(req).toPromise();
  }
}
